import React from 'react';
import './Modal.css';

const Modal = ({ 
  isOpen, 
  title, 
  message, 
  txHash, 
  error, 
  isLoading, 
  onClose 
}) => {
  if (!isOpen) return null;

  // Update the URL as needed (this example uses BSC testnet)
  const bscScanUrl = txHash ? `https://testnet.bscscan.com/tx/${txHash}` : null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {title && <h2 className="modal-title">{title}</h2>}
        {isLoading && <div className="loader"></div>}
        <p className="modal-message">{message}</p>
        {txHash && (
          <p className="modal-tx">
            View Transaction:{' '}
            <a href={bscScanUrl} target="_blank" rel="noopener noreferrer">
              {txHash.slice(0,10) + "..."}
            </a>
          </p>
        )}
        {error && <p className="modal-error">{error}</p>}
        <button className="buy-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Modal;
